export const PERMISSIONS_LIST = {
  blogsFullAccess: 'blogsFullAccess',
  blogsReadAccess: 'blogsReadAccess',
  blogsCreateAccess: 'blogsCreateAccess',
  blogsModifyAccess: 'blogsModifyAccess',
  blogsDeleteAccess: 'blogsDeleteAccess',
  propertiesFullAccess: 'propertiesFullAccess',
  usersFullAccess: 'usersFullAccess',
  areasFullAccess: 'areasFullAccess',
  roomsFullAccess: 'roomsFullAccess',
  bookingsFullAccess: 'bookingsFullAccess',
  reservationsFullAccess: 'reservationsFullAccess',
  reservationsReadAccess: 'reservationsReadAccess',
  permissionsFullAccess: 'permissionsFullAccess',
  paymentsFullAccess: 'paymentsFullAccess',
  paymentsCreateAccess: 'paymentsCreateAccess',
  propertiesModifyAccess: 'propertiesModifyAccess',
  areasModifyAccess: 'areasModifyAccess',
  bookingsModifyAccess: 'bookingsModifyAccess',
  reservationsModifyAccess: 'reservationsModifyAccess',
  paymentsModifyAccess: 'paymentsModifyAccess',
  paymentsDeleteAccess: 'paymentsDeleteAccess',
  usersModifyAccess: 'usersModifyAccess',
  roomsModifyAccess: 'roomsModifyAccess',
  permissionsModifyAccess: 'permissionsModifyAccess',
  ticketsFullAccess: 'ticketsFullAccess',
  ticketsReadAccess: 'ticketsReadAccess',
  ticketsCreateAccess: 'ticketsCreateAccess',
  ticketsModifyAccess: 'ticketsModifyAccess'
};
